<template>
  <FormItem
    :prop="prop"
    :label="label"
  >
    <Input
      v-model="val"
      type="textarea"
      :autosize="autosize"
    />
  </FormItem>
</template>

<script>
  import { FormItem, Input } from 'iview';

  export default {
    components: { FormItem, Input },
    props: {
      prop: {
        type: String,
        default: null
      },
      label: {
        type: String,
        default: null
      },
      value: {
        type: String,
        default: null
      },
      autosize: {
        type: Object,
        default: () => ({ minRows: 2, maxRows: 5 })
      }
    },
    computed: {
      val: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    }
  };
</script>